import { Type } from 'class-transformer';
import { WorkOrderDocumentAttachRawDto } from './work-order-document-attach-raw-dto';

export class WorkAuthorizationAddDocumentParametersDto {
    @Type(() => WorkOrderDocumentAttachRawDto)
    document: WorkOrderDocumentAttachRawDto;

    communityId: number;
    workOrderId: number;
}
